/**
 * パネルアイテム種別
 */
export var MessageItemTypes;

(function (MessageItemTypes) {
  /**
   * 通常
   */
  MessageItemTypes[MessageItemTypes["Normal"] = 0] = "Normal";
  /**
   * 正解
   */

  MessageItemTypes[MessageItemTypes["Correct"] = 1] = "Correct";
  /**
   * 不正解
   */

  MessageItemTypes[MessageItemTypes["Incorrect"] = 2] = "Incorrect";
})(MessageItemTypes || (MessageItemTypes = {}));